module.exports = __webpack_public_path__ + "img/6.26e69136.png";